import {RouterProps} from "../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import React, {useCallback, useEffect} from "react";
import {UserIO} from "../../io/UserIO";
import {Button, Title3} from "@fluentui/react-components";
import {PostEnumField, PostFieldWrapper} from "../PostField";
import {UserDescription} from "../../data/description/user/UserDescription";
import {UserValueObject} from "../../data/value-object/user/UserValueObject";
import {UserRole} from "../../data/constant/user/UserRole";

enum Phase {
    Loading,
    Waiting,
    Putting,
    Finished,
}

export default function EditRole(props: RouterProps) {
    const params = useParams<{ userId: string }>()
    const item = useStatePair<UserValueObject | undefined>(undefined)
    const phase = useStatePair<Phase>(Phase.Loading)
    const role = useStatePair<UserRole>(UserRole.Guest)

    useEffect(() => {
        if (params.userId !== undefined) {
            UserIO
                .getVerboseById(BigInt(params.userId))
                .then(value => {
                    item.setter(value)
                    role.setter(value.role)
                    phase.setter(Phase.Waiting)
                })
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    const onDoneClick = useCallback(() => {
        const id = item.value?.id
        if (id === undefined) {
            return
        }

        phase.setter(Phase.Putting)
        UserIO
            .patchRole(id, {
                role: role.value
            })
            .then(() => {
                phase.setter(Phase.Finished)
                alert('수정되었습니다.')
                document.location = `/users/${id}`
            })
            .catch(reason => {
                console.error(reason)
                alert('수정을 실패했습니다.')
                phase.setter(Phase.Waiting)
            })
    }, [role.value])

    return <>
        <div className={props.styles.column16}>
            <Title3>권한 수정</Title3>
            <PostFieldWrapper
                {...props}
                title={UserDescription.adminPermission}>
                <PostEnumField
                    {...props}
                    value={role.value}
                    setter={role.setter}
                    selections={UserRole.selections} />
            </PostFieldWrapper>
            <div className={props.styles.row}>
                <Button
                    appearance={'primary'}
                    disabled={phase.value !== Phase.Waiting}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </div>
        </div>
    </>
}